import React from 'react';
import { motion } from 'framer-motion';

interface AboutSectionProps {
  sobreImage: string;
}

const AboutSection: React.FC<AboutSectionProps> = ({
  sobreImage,
}) => {
  return (
    <motion.section 
      id="sobre" 
      className="py-14 sm:py-18 md:py-24 bg-white"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:grid md:grid-cols-2 gap-8 md:gap-14 items-start">
          <motion.div
            className="order-2 md:order-1 mt-6 md:mt-0 flex flex-col gap-6 w-full"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="w-full max-w-md md:max-w-full overflow-hidden rounded-2xl border border-[#d7deeb] bg-white shadow-[0_20px_55px_rgba(27,45,78,0.16)] transition-shadow duration-500 hover:shadow-[0_30px_70px_rgba(27,45,78,0.24)]">
              <img
                src={sobreImage}
                alt="Eliane Forti Fernandes - Psicóloga"
                className="w-full h-auto object-cover object-center transition-transform duration-500 hover:scale-[1.03]"
                width="600"
                height="400"
                loading="lazy"
              />
            </div>
            <div className="flex flex-wrap items-center gap-3">
              <div className="rounded-lg border border-[#d6deec] bg-[#f8faff] px-4 py-2 text-[#2a3c5c] font-medium transition-all duration-200 hover:bg-[#e8effa] hover:border-[#b5c5de] cursor-default select-none">CRP 06/216637</div>
              <div className="rounded-lg border border-[#d6deec] bg-[#f8faff] px-4 py-2 text-[#2a3c5c] font-medium transition-all duration-200 hover:bg-[#e8effa] hover:border-[#b5c5de] cursor-default select-none">{'Especializa\u00e7\u00e3o Albert Einstein'}</div>
              <div className="rounded-lg border border-[#d6deec] bg-[#f8faff] px-4 py-2 text-[#2a3c5c] font-medium transition-all duration-200 hover:bg-[#e8effa] hover:border-[#b5c5de] cursor-default select-none">{'Atendimento presencial e online'}</div>
            </div>
            <a
              href="#contato"
              className="inline-flex items-center justify-center rounded-lg bg-[#2a3c5c] px-7 py-3 text-white font-semibold transition duration-300 hover:bg-[#1f2f4c] w-full sm:w-fit"
            >
              {'Quero iniciar meu processo terap\u00eautico'}
            </a>
          </motion.div>
          <motion.div
            className="order-1 md:order-2"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <span className="inline-flex rounded-full bg-[#edf2fb] border border-[#d7deeb] px-4 py-2 text-xs tracking-[0.16em] uppercase text-[#2a3c5c] font-medium">
              {'Sobre o atendimento'}
            </span>
            <h2 className="text-3xl sm:text-4xl font-semibold mt-4 mb-6 text-[#2a3c5c] leading-tight">
              {'Escuta cl\u00ednica para mudan\u00e7as reais na sua vida'}
            </h2>
            <p className="text-gray-700 mb-4 text-lg leading-relaxed">
              {'Sou psic\u00f3loga com especializa\u00e7\u00e3o (p\u00f3s-gradua\u00e7\u00e3o lato sensu) em Psicanálise e Sa\u00fade pelo Hospital Israelita Albert Einstein. Atendo adolescentes e adultos em um espa\u00e7o de escuta profunda e \u00e9tica, onde cada hist\u00f3ria \u00e9 acolhida em sua singularidade, sem julgamentos e sem pressa.'}
            </p>
            <p className="text-gray-700 mb-4 text-lg leading-relaxed">
              {'Meu trabalho n\u00e3o se baseia em respostas prontas ou f\u00f3rmulas r\u00e1pidas. A proposta \u00e9 caminhar ao seu lado na compreens\u00e3o dos seus sentimentos, padr\u00f5es e conflitos, favorecendo mudan\u00e7as mais conscientes e transforma\u00e7\u00f5es que fa\u00e7am sentido para a sua hist\u00f3ria. Acredito na pot\u00eancia da palavra como instrumento de elabora\u00e7\u00e3o e transforma\u00e7\u00e3o ps\u00edquica.'}
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              {'Desde 2024, integro o Programa de Expedi\u00e7\u00f5es Cient\u00edficas e Assistenciais (PECA), da Faculdade de Ci\u00eancias M\u00e9dicas da Santa Casa de S\u00e3o Paulo, projeto de extens\u00e3o universit\u00e1ria voltado ao cuidado integral em diferentes realidades sociais. Essa experi\u00eancia amplia meu olhar cl\u00ednico e fortalece meu compromisso com uma escuta sens\u00edvel, respons\u00e1vel e atenta \u00e0s singularidades de cada sujeito.'}
            </p>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default AboutSection;

